import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from "../BaseApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const ApprovalTrackerSlice = createSlice({
    name: 'approvalTrackerSection',
    initialState: {
        updateApprovalTrackerFlow: {},
        getApprovalTrackerProgress: [],
    },
    reducers: {},
    extraReducers: {
        'approvalTrackerSection/updateApprovalTrackerFlow/fulfilled': (state, action) => {
            state.updateApprovalTrackerFlow = ResponseApi(action.payload);
        },
        'approvalTrackerSection/getApprovalTrackerProgress/fulfilled': (state, action) => {
            state.getApprovalTrackerProgress = ResponseApi(action.payload);
        },
    },
});

export const {} = ApprovalTrackerSlice.actions;

export default ApprovalTrackerSlice.reducer;
